import { render } from "./newFolderPanel.vue?vue&type=template&id=47f4874a"
import script from "./newFolderPanel.vue?vue&type=script&lang=js"
export * from "./newFolderPanel.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/www.usevia.cn/fileManage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__